import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import ButtonComponent, { BUTTON_HEIGHT_32 } from '../../../Button'

import * as styles from './WidgetContentFilesDownloadButton.module.css'

import ExportIcon from '../../../../icons/export.svg'

function WidgetContentFilesDownloadButton({
  Button = ButtonComponent.Outlined,
  className = styles.WidgetContentFilesDownloadButton,
  height = BUTTON_HEIGHT_32,
  loading,
  tooltipKey = 'Common.ProfileWidgetDocumentsItemDownloadBtnTooltipKey',
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Button
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: ExportIcon }}
      className={className}
      height={height}
      isLoading={loading}
      tooltip={loading ? null : t(tooltipKey)}
      tooltipPlacement={tooltipPlacement}
    />
  )
}

export default WidgetContentFilesDownloadButton
